import React from 'react';
import TextField from '@FormComponents/TextField';

const ZipCode = ({settings, ...rest}) => {
  const {name, setState} = settings || {};
  // Only numbers are allowed up to 5 digits.
  rest.onChange = (e) => {
    setState((prev) => {
      return {
        ...prev,
        [name]: e.target.value.replace(/\D/g, '').substring(0, 5),
      };
    });
  };
  return (
    <TextField {...rest} />
  );
};

export default ZipCode;
